import picsioConfig from '../../../../config';

let intercomEventSessionStarted = false;

const getStoreUser = () => {
  try {
    // Lazy require avoids a store <-> service circular dependency at module init.
    // eslint-disable-next-line global-require
    const store = require('../store').default;
    return store?.getState()?.user;
  } catch (_err) {
    return undefined;
  }
};

const resolveIntercomUser = (user) => user || getStoreUser();

export const resetIntercomEventSession = () => {
  intercomEventSessionStarted = false;
};

/** Call after app-level Intercom boot so event tracking does not boot again. */
export const markIntercomEventSessionStarted = () => {
  intercomEventSessionStarted = true;
};

export const getIntercomUserIdentityPayload = (user = {}) => {
  const payload = {
    last_request_at: Math.floor(Date.now() / 1000),
  };
  const userId = user._id || user.id;

  if (userId) payload.user_id = userId;
  if (user.email) payload.email = user.email;
  if (user.intercomHMAC) payload.user_hash = user.intercomHMAC;

  return payload;
};

/**
 * Boots Intercom for users without chatSupport (e.g. Solo) before trackEvent/update.
 * Identifies the user so events are attributed in Intercom admin.
 */
export const ensureIntercomSessionForUser = (user = {}) => {
  if (!window.Intercom || !picsioConfig.intercom?.enabled) return;

  const identity = getIntercomUserIdentityPayload(user);
  if (!identity.user_id && !identity.email) return;

  const chatSupport = user.subscriptionFeatures?.chatSupport;

  if (!chatSupport && !intercomEventSessionStarted) {
    window.Intercom('boot', {
      app_id: picsioConfig.intercom.appId,
      hide_default_launcher: true,
      ...identity,
    });
    intercomEventSessionStarted = true;
    return;
  }

  window.Intercom('update', {
    ...identity,
    ...(!chatSupport ? { hide_default_launcher: true } : {}),
  });
};

const sendEventToIntercom = (eventName, metadata, user) => {
  if (!window.Intercom) return;

  const intercomUser = resolveIntercomUser(user);
  if (intercomUser) ensureIntercomSessionForUser(intercomUser);

  window.Intercom('trackEvent', eventName, metadata);
};

export const updateIntercomUserAttributes = (user, attributes = {}) => {
  if (!window.Intercom) return;

  const intercomUser = resolveIntercomUser(user);
  if (intercomUser) ensureIntercomSessionForUser(intercomUser);

  window.Intercom('update', {
    ...getIntercomUserIdentityPayload(intercomUser || {}),
    ...attributes,
  });
};

export default sendEventToIntercom;
